var map = {
	"./articles/article_placeholder--basic.png": 392,
	"./articles/article_placeholder.png": 393,
	"./banners/banner_placeholder--mobile.png": 394,
	"./banners/banner_placeholder.png": 395,
	"./banners/editor_banner.jpg": 396,
	"./banners/galaxy-s20-fe_banner.jpg": 397,
	"./banners/galaxy-tab-s7_banner.jpg": 398,
	"./banners/nespresso_banner.png": 399,
	"./banners/nespresso_banner_mobile.png": 400,
	"./banners/nespresso_offer_banner.png": 401,
	"./banners/offer_banner_placeholder.png": 402,
	"./banners/product_category_banner-2.jpg": 403,
	"./banners/product_category_banner.jpg": 404,
	"./banners/samsung_banner.png": 405,
	"./banners/samsung_banner_mobile.png": 406,
	"./brand_logos/a4tech.png": 407,
	"./brand_logos/amica.png": 408,
	"./brand_logos/bissell.png": 409,
	"./brand_logos/blaupunkt.png": 410,
	"./brand_logos/bloody.png": 411,
	"./brand_logos/braun.png": 412,
	"./brand_logos/delonghi.png": 413,
	"./brand_logos/hitachi.png": 414,
	"./brand_logos/kenwood.png": 415,
	"./brand_logos/navon.png": 416,
	"./brand_logos/nintendo_switch.png": 417,
	"./brand_logos/oral-b.png": 418,
	"./brand_logos/panasonic.png": 419,
	"./brand_logos/samsung-white.svg": 420,
	"./brand_logos/samsung.png": 421,
	"./brand_logos/samsung_basic.svg": 422,
	"./brand_logos/xiaomi.png": 423,
	"./carousel/slide_1.jpg": 424,
	"./carousel/slide_3.jpg": 425,
	"./editor/canvas-frame-lg.svg": 271,
	"./editor/canvas-frame-md.svg": 272,
	"./editor/canvas.svg": 273,
	"./editor/editor_preview-1.webp": 274,
	"./editor/editor_preview-2.webp": 275,
	"./editor/editor_preview-3.webp": 276,
	"./editor/editor_preview-4.webp": 277,
	"./editor/editor_preview-5.webp": 278,
	"./editor/editor_preview-map.webp": 279,
	"./editor/editor_preview-star_map.webp": 280,
	"./editor/frame-icon_1.png": 281,
	"./editor/frame-icon_2.png": 282,
	"./editor/frame-icon_3.png": 283,
	"./editor/gallery_image-1.jpg": 284,
	"./editor/gallery_image-2.jpg": 285,
	"./editor/gallery_image-3.jpg": 286,
	"./editor/gallery_image-4.jpg": 287,
	"./editor/gallery_image-5.jpg": 288,
	"./editor/horizontal-orientatio-icon.svg": 289,
	"./editor/rigid-material.svg": 290,
	"./editor/star-map-hero-sample-2.png": 291,
	"./editor/star-map-hero-sample.png": 292,
	"./editor/vertical-orientation-icon.svg": 293,
	"./frames/frame_1.png": 302,
	"./frames/frame_1.webp": 248,
	"./frames/frame_2.png": 303,
	"./frames/frame_2.webp": 249,
	"./frames/frame_3.png": 304,
	"./frames/frame_3.webp": 250,
	"./product_banner.jpg": 426,
	"./product_category_previews/product_category_preview-4.jpg": 427,
	"./product_category_previews/product_category_preview_image-2.jpg": 428,
	"./product_category_previews/product_category_preview_image-3.jpg": 429,
	"./product_category_previews/product_category_preview_image-4.webp": 430,
	"./product_category_previews/product_category_preview_image-5.webp": 305,
	"./product_category_previews/product_category_preview_image-6-b.webp": 267,
	"./product_category_previews/product_category_preview_image-6.webp": 431,
	"./product_category_previews/product_category_preview_image-7.webp": 247,
	"./product_category_previews/product_category_preview_image.jpg": 432,
	"./products/feautured_product-placeholder.png": 433,
	"./products/nespresso_limited_vertuo_next_black.jpg": 434,
	"./products/nespresso_limited_vertuo_next_jade.jpg": 435,
	"./products/product-placeholder-1.png": 436,
	"./products/product-placeholder-10.png": 437,
	"./products/product-placeholder-11.png": 438,
	"./products/product-placeholder-12.png": 439,
	"./products/product-placeholder-13.png": 440,
	"./products/product-placeholder-14.png": 441,
	"./products/product-placeholder-15.png": 442,
	"./products/product-placeholder-16.png": 443,
	"./products/product-placeholder-17.png": 444,
	"./products/product-placeholder-18.png": 445,
	"./products/product-placeholder-19.png": 446,
	"./products/product-placeholder-2.png": 447,
	"./products/product-placeholder-20.png": 448,
	"./products/product-placeholder-21.png": 449,
	"./products/product-placeholder-22.png": 450,
	"./products/product-placeholder-23.png": 451,
	"./products/product-placeholder-24.png": 452,
	"./products/product-placeholder-25.png": 453,
	"./products/product-placeholder-26.png": 454,
	"./products/product-placeholder-27.png": 455,
	"./products/product-placeholder-28.png": 456,
	"./products/product-placeholder-29.png": 457,
	"./products/product-placeholder-3.png": 458,
	"./products/product-placeholder-30.png": 459,
	"./products/product-placeholder-31.png": 460,
	"./products/product-placeholder-32.png": 461,
	"./products/product-placeholder-33.png": 462,
	"./products/product-placeholder-34.png": 463,
	"./products/product-placeholder-35.png": 464,
	"./products/product-placeholder-36.png": 465,
	"./products/product-placeholder-37.png": 466,
	"./products/product-placeholder-38.png": 467,
	"./products/product-placeholder-39.png": 468,
	"./products/product-placeholder-4.png": 469,
	"./products/product-placeholder-40.png": 470,
	"./products/product-placeholder-41.png": 471,
	"./products/product-placeholder-42.png": 472,
	"./products/product-placeholder-43.png": 473,
	"./products/product-placeholder-44.png": 474,
	"./products/product-placeholder-45.png": 475,
	"./products/product-placeholder-46.png": 476,
	"./products/product-placeholder-47.png": 477,
	"./products/product-placeholder-48.png": 478,
	"./products/product-placeholder-49.png": 479,
	"./products/product-placeholder-5.png": 480,
	"./products/product-placeholder-50.png": 481,
	"./products/product-placeholder-51.png": 482,
	"./products/product-placeholder-52.png": 483,
	"./products/product-placeholder-53.png": 484,
	"./products/product-placeholder-54.png": 485,
	"./products/product-placeholder-55.png": 486,
	"./products/product-placeholder-56.png": 487,
	"./products/product-placeholder-57.png": 488,
	"./products/product-placeholder-58.png": 489,
	"./products/product-placeholder-59.png": 490,
	"./products/product-placeholder-6.png": 491,
	"./products/product-placeholder-60.png": 492,
	"./products/product-placeholder-61.png": 493,
	"./products/product-placeholder-62.png": 494,
	"./products/product-placeholder-63.png": 495,
	"./products/product-placeholder-64.png": 496,
	"./products/product-placeholder-65.png": 497,
	"./products/product-placeholder-66.png": 498,
	"./products/product-placeholder-67.png": 499,
	"./products/product-placeholder-68.png": 500,
	"./products/product-placeholder-69.png": 501,
	"./products/product-placeholder-7.png": 502,
	"./products/product-placeholder-70.png": 503,
	"./products/product-placeholder-71.png": 504,
	"./products/product-placeholder-72.png": 505,
	"./products/product-placeholder-73.png": 506,
	"./products/product-placeholder-74.png": 507,
	"./products/product-placeholder-75.png": 508,
	"./products/product-placeholder-76.png": 509,
	"./products/product-placeholder-77.png": 510,
	"./products/product-placeholder-78.png": 511,
	"./products/product-placeholder-79.png": 512,
	"./products/product-placeholder-8.png": 513,
	"./products/product-placeholder-80.png": 514,
	"./products/product-placeholder-81.png": 515,
	"./products/product-placeholder-82.png": 516,
	"./products/product-placeholder-83.png": 517,
	"./products/product-placeholder-84.png": 518,
	"./products/product-placeholder-85.png": 519,
	"./products/product-placeholder-86.png": 520,
	"./products/product-placeholder-87.png": 521,
	"./products/product-placeholder-88.png": 522,
	"./products/product-placeholder-89.png": 523,
	"./products/product-placeholder-9.png": 524,
	"./products/product-placeholder-90.png": 525,
	"./products/product-placeholder-91.png": 526,
	"./products/product-preview-1.png": 527,
	"./products/product-preview-10.png": 528,
	"./products/product-preview-11.png": 529,
	"./products/product-preview-12.png": 530,
	"./products/product-preview-13.png": 531,
	"./products/product-preview-14.png": 532,
	"./products/product-preview-15.png": 533,
	"./products/product-preview-16.png": 534,
	"./products/product-preview-17.png": 535,
	"./products/product-preview-18.png": 536,
	"./products/product-preview-19.png": 537,
	"./products/product-preview-2.png": 538,
	"./products/product-preview-20.png": 539,
	"./products/product-preview-21.png": 540,
	"./products/product-preview-22.png": 541,
	"./products/product-preview-23.png": 542,
	"./products/product-preview-24.png": 543,
	"./products/product-preview-25.png": 544,
	"./products/product-preview-26.png": 545,
	"./products/product-preview-27.png": 546,
	"./products/product-preview-28.png": 547,
	"./products/product-preview-29.png": 548,
	"./products/product-preview-3.png": 549,
	"./products/product-preview-30.png": 550,
	"./products/product-preview-31.png": 551,
	"./products/product-preview-32.png": 552,
	"./products/product-preview-33.png": 553,
	"./products/product-preview-34.png": 554,
	"./products/product-preview-35.png": 555,
	"./products/product-preview-36.png": 556,
	"./products/product-preview-37.png": 557,
	"./products/product-preview-38.png": 558,
	"./products/product-preview-39.png": 559,
	"./products/product-preview-4.png": 560,
	"./products/product-preview-40.png": 561,
	"./products/product-preview-41.png": 562,
	"./products/product-preview-42.png": 563,
	"./products/product-preview-43.png": 564,
	"./products/product-preview-44.png": 565,
	"./products/product-preview-45.png": 566,
	"./products/product-preview-46.png": 567,
	"./products/product-preview-47.png": 568,
	"./products/product-preview-48.png": 569,
	"./products/product-preview-49.png": 570,
	"./products/product-preview-5.png": 571,
	"./products/product-preview-50.png": 572,
	"./products/product-preview-51.png": 573,
	"./products/product-preview-52.png": 574,
	"./products/product-preview-53.png": 575,
	"./products/product-preview-54.png": 576,
	"./products/product-preview-55.png": 577,
	"./products/product-preview-56.png": 578,
	"./products/product-preview-57.png": 579,
	"./products/product-preview-58.png": 580,
	"./products/product-preview-59.png": 581,
	"./products/product-preview-6.png": 582,
	"./products/product-preview-60.png": 583,
	"./products/product-preview-61.png": 584,
	"./products/product-preview-62.png": 585,
	"./products/product-preview-63.png": 586,
	"./products/product-preview-64.png": 587,
	"./products/product-preview-65.png": 588,
	"./products/product-preview-66.png": 589,
	"./products/product-preview-67.png": 590,
	"./products/product-preview-68.png": 591,
	"./products/product-preview-69.png": 592,
	"./products/product-preview-7.png": 593,
	"./products/product-preview-70.png": 594,
	"./products/product-preview-71.png": 595,
	"./products/product-preview-72.png": 596,
	"./products/product-preview-73.png": 597,
	"./products/product-preview-74.png": 598,
	"./products/product-preview-75.png": 599,
	"./products/product-preview-76.png": 600,
	"./products/product-preview-77.png": 601,
	"./products/product-preview-78.png": 602,
	"./products/product-preview-79.png": 603,
	"./products/product-preview-8.png": 604,
	"./products/product-preview-80.png": 605,
	"./products/product-preview-81.png": 606,
	"./products/product-preview-82.png": 607,
	"./products/product-preview-83.png": 608,
	"./products/product-preview-84.png": 609,
	"./products/product-preview-85.png": 610,
	"./products/product-preview-86.png": 611,
	"./products/product-preview-87.png": 612,
	"./products/product-preview-88.png": 613,
	"./products/product-preview-89.png": 614,
	"./products/product-preview-9.png": 615,
	"./products/product-preview-90.png": 616,
	"./products/product-preview-91.png": 617,
	"./products/product_accessory-2.png": 618,
	"./products/product_accessory.png": 619,
	"./products/product_placeholder--basic.png": 620,
	"./products/product_placeholder.jpg": 621,
	"./products/samsung-galaxy-book-s-2.jpg": 622,
	"./products/samsung-galaxy-book-s-3.jpg": 623,
	"./products/samsung-galaxy-book-s-4.jpg": 624,
	"./products/samsung-galaxy-book-s-5.jpg": 625,
	"./products/samsung-galaxy-book-s.jpg": 626,
	"./products/samsung_QE55Q70AATXXH.jpg": 627,
	"./products/samsung_a217f.jpg": 628,
	"./products/samsung_as17f_purple.jpg": 629,
	"./products/samsung_g991b.jpg": 630,
	"./products/samsung_g998b.jpg": 631,
	"./products/samsung_galaxy_book_s.jpg": 632,
	"./products/samsung_galaxy_book_s.png": 633,
	"./products/xbox_wireless_controller.jpg": 634,
	"./products/xbox_wireless_headset.jpg": 635,
	"./sample.jpg": 636,
	"./star_map_editor/frame--horizontal.png": 251,
	"./star_map_editor/frame_1.png": 252,
	"./star_map_editor/frame_2.png": 253,
	"./star_map_editor/frame_3.png": 254,
	"./star_map_editor/shadow--horizontal.png": 255,
	"./star_map_editor/shadow--horizontal.webp": 256,
	"./star_map_editor/shadow.png": 257,
	"./star_map_editor/shadow.webp": 258,
	"./star_map_editor/star-map.svg": 259,
	"./star_map_editor/star-map_bg-1.png": 260,
	"./star_map_editor/star-map_bg-2.png": 261,
	"./star_map_editor/star-map_bg-3.png": 262,
	"./star_map_editor/star-map_bg-4.png": 263,
	"./star_map_editor/star-map_bg-5.png": 264,
	"./star_map_editor/star-map_black.png": 265,
	"./star_map_editor/star-map_white.png": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1141;